






















/* eslint-disable */
import { Vue, Component, Prop } from "vue-property-decorator"
import PopUpUI from "./PopUpUI.vue";

import * as proj from "ol/proj";
import * as control from "ol/control";

import { GOOGLE_MAPS_API_KEY } from "./data/basemaps";

import { loader as GoogleMapApiLoader } from "./GoogleMapApiLoader";
import { defaults as olgmDefauls } from 'olgm/interaction.js';

import NativeMap from "ol/Map";
import View from "ol/View";
import MousePosition from "ol/control/MousePosition";
import Rotate from "ol/control/Rotate";
import DragRotate from "ol/interaction/DragRotate";

import { Scale } from "./tools/Scale";

import { IMapOptions, IMap, IMapViewInfo, 
         IBaseMapSource, IUndoRedo } from "./types";
import { IUser, EUserGroup } from "../shared/types";

import Map from "./Map";

import { BASEMAP, DEFAULT_BASEMAP, BASEMAP_INTERNAL_WMS } from "./data/basemaps";
import { DEFAULT_VIEW_CENTER,
         DEFAULT_MAP_OPTIONS,
         MAP_EXTENT,
         VIEW_PADDING
} from './Map';

import { ScreenDPI } from "../../common/utils";

@Component({
  name: "ol-map",
  components: { PopUpUI },
  watch: {
    basemap(val) {
      let vInfo:IMapViewInfo = this.getViewInfo();
      if (val=='gistda.thaichote' && vInfo.zoom>=16) {
        val = this.map.HasGoogleMap ? 'google.satellite' : 'bing.aerial';
      }
      this.changeBaseMap(val);
    },
    extent(val) {
      //this.changeMapExtent(val);
      this.changeMapView('zoomToExtent', {extent:val});
    },
    center(val) {
      this.changeMapView('setCenterAt',{
        center: val
      });
    },
    padding(val) {
      //this.viewProps.padding = val;
      this.ViewPadding = val;
    },
    nodrag(val) {
      this.enabledisabledragzoom(val);
    }
  }
})
export default class MapUI extends Map {
  // these are element attributes
  // in typescript use !: "definite assignment assertion"
  // to force a variable be not null 
  // use default() to set prop initial value. 
  // don't directly assign value to prop otherwise,
  // it will warn avaoiding mutating prop ...
  @Prop({
    default: 0
  }) tabIndex: number;
  @Prop({
    default: false
  }) samllMobile: boolean;
  @Prop({
    default: () => { return DEFAULT_BASEMAP; }
  }) private basemap: string;
  @Prop({
    default: () => { return VIEW_PADDING; }
  }) private padding: number[];
  @Prop({
    default: () => { return DEFAULT_VIEW_CENTER; }
  }) private center: number[];
  @Prop({
    default: false
  }) private showPaddingCenter: boolean;
  @Prop({
    default: null
  }) private extent: [number,number,number,number];
  @Prop({
    default: 12
  }) private zoom: number; // = 12;
  @Prop({
    default: 'scale'
  }) private scale: string;
  @Prop({
    default: 'wgs84'
  }) private wgs84: string;
  @Prop({
    default: 'utm'
  }) private utm: string;
  @Prop({
    default: 'compass'
  }) private compass: string;
  @Prop({
    default: null //'getInfo'
  }) private action: string;
  @Prop({
    default: false
  }) private gettingInfo: boolean;
  @Prop({
    default: null
  }) undoRedo: IUndoRedo;
  @Prop({
    default: false
  }) private nodrag: boolean;

  created() {
    this.map.Id = 'v' + (new Date()).getTime();
    let dpi = ScreenDPI();
    this.map.XDPI = dpi.x || 96;
    this.map.YDPI = dpi.y || 96;
  };
  
  get MapUIPadding() : string {
    return 'top:' + this.padding[0] + 'px;right:' + this.padding[1] + 'px;' +
           'bottom:' + this.padding[2] + 'px;left:' + this.padding[3] + 'px';
  }
  //paddingCenterPosition = 'left:calc(50% - 32px);top:calc(50% - 32px)';
  mounted() {
    this.viewProps = {
      extent: this.extent,
      padding: this.padding,
      center: this.center,
      zoom: this.zoom
    };
    let olMap = this.map.NativeMap;
    if (!olMap || (<HTMLElement>olMap.getTarget()).id != this.map.Id) {
      let bm : IBaseMapSource;
      if (!this.map.BaseMap) {
        bm = this.createBaseMaps(this.basemap);
      } else {
        bm = this.getBaseMap(this.basemap);
      }
      let noInternet = !!window.location.pathname.substr(1).match(/nointernet/i);
      if (noInternet) {
        bm = this.createBaseMap(BASEMAP_INTERNAL_WMS, BASEMAP_INTERNAL_WMS.Maps[0]);
      }
      this.map.BaseMap = bm.Layer;
      this.map.BaseMapType = bm.IsImage ? 'image' : 'map';
      // dont use DEFAULT_MAP_OPTIONS, otherwise, when create multiple map instances,
      // map controls will be set to the last map instance
      let options = Object.assign({}, {
          interactions: olgmDefauls(),
          controls: control.defaults({
            zoom: false, 
            rotate: false,
            attribution: true,
            attributionOptions: {
              collapsible:true, 
              collapsed:false,
              collapseLabel: '◁' /* since we put attributions at left side*/
            }
          }),
          loadTilesWhileInteracting: true, 
          keyboardEventTarget:'Element'
        },{
          target: <HTMLElement>this.$el.querySelector('#' + this.map.Id),
          layers: [
            this.map.BaseMap
          ],
          pixelRatio: 1, // IMPORTANT, otherwise tiles with strange size will be requested
          view: new View({
            center: proj.fromLonLat(this.center),
            zoom: this.zoom
          })
        });
      this.map.NativeMap = this.createMap(options);
      //todo: olgm does not support ol style function
      //this.activateOlGoogleMaps('google.road');

      if (this.extent) {
        this.viewProps.center = [
          (this.extent[0] + this.extent[2]) / 2,
          (this.extent[1] + this.extent[3]) / 2
        ];
        this.changeMapView('zoomToExtent');
      } else {
        this.changeMapView('setCenterAt',{center:this.center,zoom:this.zoom});
      }
      if (this.nodrag) {
        this.enabledisabledragzoom(this.nodrag);
      }

      // application specific layers and internal controls
      this.createWorkingLayersAndControls();

      if (this.action) {
        this.setMapAction(this.action,null);
      }
      this.attachMapEvents();
      this.$emit('created', <Map> this);
    }
    this.map.NativeMap['SOFTOO_MAP'] = this;
    //now create basemap of WMTS, such as GISTDA Planet
    //WMTS requires this.map.NativeMap be already created
    //But WMTS not working for BaseMap. We use XYZ layer instead of
    //if (!BASEMAP[0].Maps[1].Layer) {
    //  this.createBaseMap(BASEMAP[0], BASEMAP[0].Maps[1]);
    //}

    if (this.undoRedo) {
      this.createUndoRedo(this.undoRedo);
    }
  };

  createMap(options:IMapOptions) {
    if (!(options && options.target)) {
      throw new Error("A target must be defined in order to create a map");
    }
    // options is an object of IMapOptions.it must have at least target defined
    // target is a dom element, such as <div>, i.e. Vue.$el
    // target parent should be a container that contains 
    // map controls such as zoom ..., and scale and mouse position readout
    let container = (<Element>options.target).parentElement;
    if (container) {
    }

    let map = new NativeMap(options);

    // create view to show scale and mouse position
    // this.scale, coordinateWgs84, ... are dom ids that are passed
    // to Vue component, i.e. ./Map.vue as its attributes
    if (container) {
      container.style.overflow = "hidden";
      let scale = <HTMLElement> container.querySelector('#' + this.scale);
      let wgs84 = <HTMLElement> container.querySelector('#' + this.wgs84);
      let utm = <HTMLElement> container.querySelector('#' + this.utm);
      let compass = <HTMLElement> container.querySelector('#' + this.compass);

      if (scale) {
        map.addControl(new Scale({
          target: scale,
          showScale: true
        }));
      }
      if (wgs84) {
        map.addControl(new MousePosition({
          target: wgs84,
          projection: 'EPSG:4326',
          coordinateFormat: this.mousePositionToWGS84
        }));
      }
      if (utm) {
        map.addControl(new MousePosition({
          target: utm,
          projection: 'EPSG:4326',
          coordinateFormat: this.mousePositionToUTM
        }));
      }
      if (compass) {
        /** modify ol.control.Rotate
            if (options.tipLabel) { //ZHANG
              button.title = tipLabel;
            }
         */
        map.addControl(new Rotate({
          target: compass,
          label: 'explore',
          className: 'icon material-icons',
          autoHide: false
        }));
        map.addInteraction(new DragRotate());
      }
    }
    this.map.NativeMap = map;
    return map;
  };
  
  emitMoveEnd(event) {
    // floating openlayer event to inside the vue's ViewModel
    let vInfo:IMapViewInfo = this.getViewInfo();
    if (this.basemap=='gistda.thaichote' && this.map.HasGoogleMap) {
      if (vInfo.zoom>=16) {
        this.changeBaseMap(this.map.HasGoogleMap ? 'google.satellite' : 'bing.aerial');
      } else {
        this.changeBaseMap(this.basemap);
      }
    }
    this.syncBaseMapViews(vInfo.paddingCenter.map,
    Math.min(15, vInfo.zoom), vInfo.rotation);
    if (this.gettingInfo) {
      let px = this.map.NativeMap.getPixelFromCoordinate(this.InfoLoaderXY);
      this.InfoLoaderPosition = 'left:' + (px[0] - 16) + 'px;' +
                                'top:' + (px[1] - 16) + 'px';
    }
    this.$emit("moveend", vInfo);
  };

  emitPointerDrag(event) {
    const feature = this.map.NativeMap.forEachFeatureAtPixel(event.pixel, feature => feature);
    let vInfo = this.getViewInfo(); // defined in ./methods.js
    this.$emit("pointerdrag", vInfo, feature);
  };

  focusOnMap(event) {
    // ensure that map view will get event whenever mouse is moving on it
    // maybe not good, such as when inputing something else.
    this.map.NativeMap.getTargetElement().focus();
  };

  attachMapEvents() {
    if (this.map.NativeMap) {
      let self = this;
      // http://openlayers.org/en/latest/apidoc/ol.Map.html#on
      this.map.NativeMap.on("moveend", this.emitMoveEnd);//, this);
      /*event => {
        // floating openlayer event to inside the vue's ViewModel
        let vInfo = this.getViewInfo(); // defined in ./methods.js
        this.syncBaseMapViews(vInfo.center.map, Math.min(15, vInfo.zoom), vInfo.rotation);
        this.$emit("moveend", event, vInfo);
      });*/
      this.map.NativeMap.on("pointerdrag", this.emitPointerDrag);//, this);
      this.map.NativeMap.on('pointermove', this.focusOnMap);//, this);
      /*event => {
        const feature = this.map.NativeMap.forEachFeatureAtPixel(event.pixel, feature => feature);
        const center = event.map.getView().getCenter();
        const zoom = event.map.getView().getZoom();
        const lonlat = proj.toLonLat(center);
        this.$emit("pointerdrag", event, lonlat, zoom, feature);
      });*/
      /*
      this.map.NativeMap.on("click", event => {
        // console.log(event.pixel)
        const feature = this.map.NativeMap.forEachFeatureAtPixel(event.pixel, feature => feature);
        if (feature)
          this.$emit("selfeature", feature);
        this.$emit("click", event, feature);
      });*/
      this.map.NativeMap.on("postcompose", this.onPostCompose);//, this);

      this.map.BaseMap.getSource().once('tileloadend', (event) => {
        this.$emit('basemapinitialized', {
          map: <Map> self,
          target: event.target,
          tile: event.tile,
          type: 'tileloadend'
        });
      });
    }
  };

  beforeDestroy () {
    this.detachMapEvents();
    this.clearOverlayLayersAndControls();
    this.$emit("destroy",this);
  };

  detachMapEvents() {
    this.map.NativeMap.un("moveend", this.emitMoveEnd);//, this);
    this.map.NativeMap.un("pointermove", this.focusOnMap);//, this);
    this.map.NativeMap.un("pointerdrag", this.emitPointerDrag);//, this);
    this.map.NativeMap.un("postcompose", this.onPostCompose);//, this);
  };

  /*autocenter() {
    // require to use https on Chrome
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(pos => {
        if (this.autoCenter) {
          this.setcenter([pos.coords.longitude, pos.coords.latitude]);
        }
      }, (error) => {
        throw error;
      });
    }
  };*/

  enabledisabledragzoom(val) {
    this.map.NativeMap.getInteractions().forEach(e => {
      e.setActive(!val);
    });
  }

  get PaddingCenterPosition() : string {
    let p = this.viewProps.padding;
    let x = 0, y = 0;
    if (p) {
      x = (p[3] - p[1]) / 2;
      y = (p[0] - p[2]) / 2;
    }
    x -= 32;
    y -= 32;
    return 'left:calc(50% + ' + x + 'px);top:calc(50% + ' + y + 'px)';
  }
}
